import { apiClient } from './apiConfig';

export interface GmailStatus {
  connected: boolean;
  email_address: string | null;
  last_sync: string | null;
  auth_url: string;
}

export const emailConfigAPI = {
  getStatus: async (): Promise<GmailStatus> => {
    const response = await apiClient.get('/api/email-config/');
    return response.data;
  },
};
